// extracted by mini-css-extract-plugin
export default {"round-edges":"PlaceSelector_round-edges__fftX6"};